<template>
  <q-linear-progress v-if="isLoading" indeterminate />
  <div v-else class="q-px-2x-md q-pt-xl">
    <div class="col-12">
      <span class="text-md text-weight-medium text-neutral">
        Pre Screening
      </span>
      <q-separator color="neutral-40" class="q-mt-xxs" />
    </div>
    <div class="text-xs text-neutral-70 q-mt-xxs">
      Checks for several data fields such as credit scores, legal cases,
      balances, delinquents and more.
    </div>
    <div class="row q-col-gutter-x-xxl q-mt-sm">
      <div class="col-6">
        <div class="text-sm text-neutral">Outcome</div>
      </div>
      <div class="col-6">
        <PBadge
          :label="preScreeningData?.outcome"
          :type="preScreeningData?.outcome"
          class="text-capitalize q-py-xxs q-px-sm"
        />
      </div>
    </div>
    <div>
      <PBtn
        label="View detailed analysis"
        flat
        :disable="
          computedBusinessDetails?.business_type?.code == 'PLC' ||
          !preScreeningData?.analysis?.length
        "
        class="q-pa-none q-mt-xxl text-sm text-weight-medium"
        @click="openPreScreeningDetails"
      >
        <PTooltip v-if="computedBusinessDetails?.business_type?.code == 'PLC'"
          >Public Limited Company</PTooltip
        >
        <PTooltip v-else-if="!preScreeningData?.analysis?.length"
          >No Analysis Present</PTooltip
        >
      </PBtn>
    </div>
  </div>
</template>
<script setup>
import { watch } from "vue";

const { verificationCenterFormState, user } = storeToRefs(useUserStore());
const { togglePreScreeningDetailForm, getUserCreditVerification } =
  useUserStore();

const preScreeningData = ref(null);

const computedBusinessDetails = computed({
  get() {
    return unref(user)?.businessDetails;
  },
});

const openPreScreeningDetails = () => {
  togglePreScreeningDetailForm({
    open: true,
    level: 1,
    props: { analysis: unref(preScreeningData)?.analysis },
  });
};

const isLoading = ref(false);

const fetchUserCreditVerificationDetails = async () => {
  try {
    isLoading.value = true;

    const response = await getUserCreditVerification({
      params: {
        stage_name: "pre_screening",
      },
    });

    await getUserCreditVerification({
      params: {
        stage_name: "direct_verification",
      },
    });

    await getUserCreditVerification({
      params: {
        stage_name: "indirect_verification",
      },
    });

    preScreeningData.value = response?.data?.data;

    isLoading.value = false;
  } catch (error) {
    console.error(error);

    isLoading.value = false;
  }
};

const computedFormState = computed(
  () => unref(verificationCenterFormState).open,
);

watch(computedFormState, async (state) => {
  if (state) {
    await fetchUserCreditVerificationDetails();
  }
});

onMounted(async () => {
  await fetchUserCreditVerificationDetails();
});
</script>
